import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { default as Axios } from 'axios';
import './search.css';
import { API_URL } from "../../config/constants";

const axios = Axios.create({
    baseURL: API_URL + "/",
});

const Search = ({ sortBy, setSortBy }) => {
    const dispatch = useDispatch();
    const [name, setName] = useState('');
    const [debouncedName, setDebouncedName] = useState('');
    const [type, setType] = useState('');
    const [selectedType, setSelectedType] = useState('');
    const [subtype, setSubtype] = useState('');
    const [selectedSubtype, setSelectedSubtype] = useState('');
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const edition = queryParams.get('edition') || 'edition1'; // Valor por defecto

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedName(name);
        }, 500);
        return () => clearTimeout(timer);
    }, [name]);

    useEffect(() => {
        request();
    }, [debouncedName, type, subtype]);

    const handleSelect = (newType) => {
        setSelectedType((prev) => (prev === newType ? '' : newType));
        setType(newType !== 'todo' ? newType : '');
        if (newType !== 'aliado') {
            setSubtype('');
            setSelectedSubtype('');
        }
    };

    const handleSubtypeSelect = (newSubtype) => {
        setSelectedSubtype((prev) => (prev === newSubtype ? '' : newSubtype));
        setSubtype(newSubtype);
    };

    const clearFilters = () => {
        setName('');
        setDebouncedName('');
        setType('');
        setSubtype('');
        setSelectedType('');
        setSelectedSubtype('');
        dispatch({ type: 'UPDATE_LISTER', payload: [] });
    };

    const request = async () => {
        dispatch({ type: 'SET_SEARCH_ACTIVE', payload: true });
        dispatch({ type: 'SET_LOADING_STATE', payload: true });

        try {
            const response = await axios.get(queryBuilder());
            const data = response.data.data;

            if (!data || data.length === 0) {
                dispatch({ type: 'UPDATE_LISTER', payload: [] });
                dispatch({ type: 'SET_NO_RESULTS', payload: true });
            } else {
                dispatch({ type: 'UPDATE_LISTER', payload: data });
                dispatch({ type: 'SET_NO_RESULTS', payload: false });
            }
        } catch (err) {
            console.error('Error en la solicitud:', err);
            const message = err.response?.data?.message || 'No se pudieron obtener cartas';
            dispatch({ type: 'SET_ERROR_MESSAGE', payload: message });
            dispatch({ type: 'UPDATE_LISTER', payload: [] });
        } finally {
            dispatch({ type: 'SET_LOADING_STATE', payload: false });
        }
    };

    const subtypeOptionsByEdition = {
        edition1: [
            { display: 'Caballero', apiValue: 'Caballero' },
            { display: 'Dragón', apiValue: 'Dragon' },
            { display: 'Faerie', apiValue: 'Faerie' }
        ],
        edition2: [
            { display: 'Héroe', apiValue: 'Heroe' },
            { display: 'Olímpico', apiValue: 'Olimpico' },
            { display: 'Titán', apiValue: 'Titan' }
        ],
        edition3: [
            { display: 'Defensor', apiValue: 'Defensor' },
            { display: 'Desafiante', apiValue: 'Desafiante' },
            { display: 'Sombra', apiValue: 'Sombra' }
        ],
        edition4: [
            { display: 'Faraón', apiValue: 'Faraon' },
            { display: 'Sacerdote', apiValue: 'Sacerdote' },
            { display: 'Eterno', apiValue: 'Eterno' }
        ]
    };

    const subtypes = subtypeOptionsByEdition[edition] || [];

    const queryBuilder = () => {
        let query = `cardinfo?edition=${edition}`;
        if (debouncedName) query += `&name=${debouncedName}`;
        if (type) query += `&tipo=${type}`;
        if (subtype) query += `&subtipo=${subtype}`;
        return query;
    };

    return (
        <div className="search">
            <h2>Tipo de Carta</h2>
            <div className="button-group">
                {['todo', 'aliado', 'arma', 'oro', 'talisman', 'totem'].map((item) => (
                    <button
                        key={item}
                        className={`search-button ${selectedType === item ? 'active' : ''}`}
                        onClick={() => handleSelect(item)}
                    >
                        {item.charAt(0).toUpperCase() + item.slice(1)}
                    </button>
                ))}
            </div>

            <div className="search-row">
                <div className="search-input-container">
                    <input
                        className="search-input"
                        type="text"
                        placeholder="Búsqueda por nombre"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                    <button className="search-button-search" onClick={request}>
                        <i className="fa-solid fa-magnifying-glass"></i>
                    </button>
                </div>

                {selectedType === 'aliado' && (
                    <div className="subtype-buttons">
                        {subtypes.map((item) => (
                            <button
                                key={item.apiValue}
                                className={`subtype-button ${selectedSubtype === item.apiValue ? 'active' : ''}`}
                                onClick={() => handleSubtypeSelect(item.apiValue)}
                            >
                                {item.display}
                            </button>
                        ))}
                    </div>
                )}
            </div>


            {/* <div className="clear-button-container">
                <button className="clear-button" onClick={clearFilters}>
                    Limpiar filtros
                </button>
            </div> */}
        </div>
    );
};

export default Search;
